/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voucher_PlaceholderInputs */

const en_voucher_placeholder = /** @type {(inputs: Voucher_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher code`)
};

const id_voucher_placeholder = /** @type {(inputs: Voucher_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode voucher`)
};

/**
* | output |
* | --- |
* | "Voucher code" |
*
* @param {Voucher_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_placeholder = /** @type {((inputs?: Voucher_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_placeholder(inputs)
	return en_voucher_placeholder(inputs)
});